export const environment = {
  production: false,
  endpoint: '/api/v1',
  version: require('../../package.json').version,
  consentLink: 'https://eportal-dev.allianz.co.th/assets/documents/consent/TH/Privacy_Notice_AllianzApp_Consent.pdf'
};
